export const dbInitialDemoData = {
    numOfUsers: 23,
    numOfPendingInvoice: 3,
    numOfPendingSubscription: 1,
    numOfExpiringSoon: 2,
    demo: true
};

export const productListDemoData = [
    {
        applicationId: 16,
        applicationName: 'Envision NEXT',
        applicationLogoUrl:
            'https://storage.googleapis.com/miracle-bucket-23/application_logo/envision-next-3.png',
        count: 2,
        demo: true
    },
    {
        applicationId: 21,
        applicationName: 'PetMatrix',
        applicationLogoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/petmatrix-1.svg',
        count: 1,
        demo: true
    },
    {
        applicationId: 20,
        applicationName: 'Envision Pulse',
        applicationLogoUrl: 'https://miracleadvance.com/wp-content/uploads/2023/09/pulse.svg',
        count: 1,
        demo: true
    }
];

export default null;
